var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"QucikIconButton-container"},[_c('el-tooltip',{attrs:{"content":_vm.tooltip,"placement":"bottom","effect":"light"}},[_c('i',{staticClass:"icon",class:_vm.clazz,on:{"click":_vm.click}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }